export const hasAny = (...args) => args.some(Boolean);
